export const getCurrentApprover = (request) => {
    return request.request_approvers.filter((approver) => {
        return !request.approved_index
          ? approver.order == 1
          : approver.order - 1 ==
              request.approved_index 
        });
};

export const getCurrentApproverSaleOc = (request) => {
  return request.sale_approvers.filter((approver) => {
      return !request.sale_approval_index
        ? approver.order == 1
        : approver.order - 1 ==
            request.sale_approval_index
    });
};

export const getSubstituteFromApprover = (approver) => {
    return approver.substituting_for[0].substitute;
 }
